export default theme => ({

  card: {
    display: 'inline-block',
    width: theme.spacing.unit * 41,
    marginTop: '10vh',
    padding: theme.spacing.unit * 3
  },

  content: {
    padding: theme.spacing.unit
  }

})



// WEBPACK FOOTER //
// ./src/styles/pages/auth/recovery.js